import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=aed0ff20&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aed0ff20')) {
      api.createRecord('aed0ff20', component.options)
    } else {
      api.reload('aed0ff20', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=aed0ff20&", function () {
      api.rerender('aed0ff20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/Carousel.vue"
export default component.exports